// CcSite/src/components/CookieConsent.js
import React, { useState, useEffect } from 'react';
import { Box, Button, HStack, IconButton, Link, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

const CONSENT_KEY = 'cc_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (!saved) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex={999}
      bg="black"
      borderTop="1px solid rgba(255,255,255,.15)"
      backdropFilter="blur(20px)"
      px={{ base: 4, md: 10 }}
      py={4}
    >
      <HStack
        justify="space-between"
        align="center"
        flexDir={{ base: 'column', md: 'row' }}
        gap={4}
      >
        <Text color="gray.300" fontSize="sm" maxW={{ base: '100%', md: '70%' }}>
          We use cookies to improve your experience and analyze site traffic. Read our{' '}
          <Link href="/privacy" color="purple.300" textDecoration="underline">
            Privacy Policy
          </Link>{' '}
          to learn more.
        </Text>

        <HStack spacing={3} flexShrink={0}>
          <Button
            size="sm"
            variant="outline"
            color="gray.300"
            borderColor="rgba(255,255,255,.3)"
            _hover={{ bg: 'rgba(255,255,255,.08)', color: 'white' }}
            onClick={handleDecline}
          >
            Decline
          </Button>
          <Button
            size="sm"
            variant="purple"
            onClick={handleAccept}
          >
            Accept All
          </Button>
          <IconButton
            size="sm"
            aria-label="Close"
            icon={<CloseIcon boxSize={2.5} />}
            variant="ghost"
            color="gray.500"
            _hover={{ color: 'white', bg: 'rgba(255,255,255,.08)' }}
            onClick={handleClose}
          />
        </HStack>
      </HStack>
    </Box>
  );
}
